import { LevelSelectSchema } from './CreateCondition';
import { ConditionBinding } from '@retail/calculus/types';

interface Props {
  levelSchema: LevelSelectSchema;
  supplierNumber?: number;
  gtinCode?: string;
}

export const getConditionBindingValuesFromLevelSchema = ({
  levelSchema,
  supplierNumber,
  gtinCode,
}: Props): ConditionBinding[] => {
  switch (levelSchema.level) {
    case 'assortment':
      return [{ assortment: { activeLevel: true } }];
    case 'supplier':
      return supplierNumber ? [{ supplier: { supplierNumber } }] : [];
    case 'productGroup': {
      const groupNumber = (
        levelSchema.productGroup ??
        levelSchema.mainGroup ??
        levelSchema.overGroup
      )?.groupNumber;
      return groupNumber ? [{ productGroup: { supplierNumber, groupNumber } }] : [];
    }
    case 'discountGroup':
      return supplierNumber
        ? levelSchema.discountGroups?.map((dg: { code: string }) => ({
            discountGroup: { groupCode: dg.code, supplierNumber },
          })) ?? []
        : [];
    case 'item':
      return levelSchema.item?.id
        ? [{ mgSupplierItem: { supplierItemId: levelSchema.item.id, gtinCode } }]
        : [];
    default:
      return [];
  }
};
